module.exports = __webpack_public_path__ + "static/media/location-rojo_old.e33747c7.svg";